import React from "react";
import Button from "../../../../../../_components/Button";
import Modal from "../../../../../../_components/Modal";
import Text from "../../../../../../_components/Text";
import LoadingInput from "../../../../../../_components/LoadingInput";
import { cancelNFe } from "../../../../../../api/nfe";
import { showSnackBar } from "../../../../../../utils";
import { toast } from "react-toastify";

export default (props) => {
  const [show, setShow] = React.useState(false);
  const [reason, setReadon] = React.useState("Cancelamento pois haviam erros");
  const [loading, setLoading] = React.useState(false);

  function onShow() {
    setShow(true);
    onSetInputFocus();
  }
  function onHide() {
    if (loading) {
      return;
    }
    setShow(false);
    setReadon("Cancelamento pois haviam erros");
  }
  function onSetInputFocus() {
    setTimeout(() => {
      try {
        document.querySelector('[name="xpto"]').focus();
      } catch (error) {}
    }, 500);
  }
  function onCancel() {
    cancelNFe(props.nfe.id);
    setLoading(true);
    cancelNFe(props.nfe.id)
      .then((resp) => {
        if (props.onFinally) {
          props.onFinally();
        }
        onHide();
        toast.success(
          <Text color="white" align="center">
            NF-e Cancelada!
          </Text>,
          {
            toastId: "success-cancel-fiscal-doc",
            position: "top-center",
          }
        );
      })
      .catch((resp) => {
        setLoading(false);
        if (resp.error) {
          toast.error(
            <Text color="white" align="center">
              {resp.error}
            </Text>,
            {
              toastId: "unsuccess-cancel-fiscal-doc",
              position: "top-center",
            }
          );
        }
      });
  }
  return (
    <React.Fragment>
      <Button
        onClick={onShow}
        as="text"
        className="text-danger"
        disabled={props.nfe.status != 1}
      >
        <i className="fas fa-times text-danger" title="Cancelar NF-e" />
      </Button>
      <Modal title="Cancelar NF-e" show={show} onHide={onHide}>
        <Text>Justificativa de cancelamento</Text>
        <LoadingInput
          name="xpto"
          value={reason}
          onChange={(e) => setReadon(e.target.value)}
        />
        <span
          className={`${reason.length < 15 ? "d-block text-danger" : "d-none"}`}
        >
          A Justificativa não pode ter menos do que <strong>15</strong>{" "}
          caracteres
        </span>
        <div className="py-3 d-flex justify-content-center">
          <Button
            onClick={onCancel}
            disabled={loading || reason.length < 15}
            as="text"
          >
            Cancelar NF-e
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/CancelNFe/index.jsx